import React from "react";
import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppButton from "@/components/AppButton";

interface ReportConfirmModal {
  onConfirm: () => void;
  onClose: () => void;
}

const ReportConfirmModal: React.FC<ReportConfirmModal> = ({ onConfirm, onClose }) => {
  return (
    <AppBox
      column
      center
      gap={8}
      fullWidth
      className="text-center p-4"
    >
      <AppText
        variant="h6"
        // color="dark"
        // align="center"
        // className="max-w-md" // Limit width for better text wrapping
      >
        Please note there is a 20 cent fee per Answered Call lead for the AI transcription/summary download. To begin the download, please click Confirm below. We will then email you the file when complete (up to 10 minutes). Thanks!
      </AppText>

      <AppBox center fullWidth gap={4}>
        <AppButton onClick={onConfirm}>Confirm</AppButton>
        <AppButton variant="outlined" onClick={onClose}>Cancel</AppButton>
      </AppBox>
    </AppBox>
  );
};

export default ReportConfirmModal;